import { HomeCampaignsItemController } from './home-campaigns-item.controller'

function homeCampaignsItem () {
  return {
    restrict: 'E',
    scope: {
      campaign: '<',
      showExpiration: '<',
      click: '&'
    },
    templateUrl: '/home/directives/home-campaigns-item/home-campaigns-item-directive.html?$$REVISION$$',
    controller: HomeCampaignsItemController
  }
}

export { homeCampaignsItem }
